import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UserService } from '../services/user.service';

@Injectable({
	providedIn: 'root',
})
export class UserHasRequiredRoleGuard implements CanActivate {
	constructor(private userService: UserService, private router: Router) {}
	canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
		const required_roles = route.data['required_roles'] || [];
		const must_have_every_role = route.data['must_have_every_role'] ?? false;
		const route_segments = this.getFullRouteSegments(route);
		return combineLatest([this.userService.user$]).pipe(
			filter((user) => !!user),
			map(([user]) => {
				if (user.roles) {
					if (must_have_every_role) {
						if (required_roles.every((role: string) => user.roles.includes(role))) {
							return true;
						}
					} else {
						if (required_roles.some((role: string) => user.roles.includes(role))) {
							return true;
						}
					}
				}

				if (route_segments.includes('admin')) {
					return this.router.createUrlTree(['admin']);
				} else if (route_segments.includes('main')) {
					return this.router.createUrlTree(['main']);
				} else {
					return false;
				}
			})
		);
	}

	private getFullRouteSegments(route: ActivatedRouteSnapshot): string[] {
		const segments: string[] = [];
		let currentRoute: ActivatedRouteSnapshot | null = route;
		while (currentRoute) {
			segments.unshift(...currentRoute.url.map((segment) => segment.path));
			currentRoute = currentRoute.parent;
		}
		return segments;
	}
}
